<div class="ax-panel">
  <app-grid name="Global Factor Risk Factor Security Detail">
  </app-grid>
</div>
